export const TRANSLATIONS_JP_SETTINGS_MICROSOFT = {
  "settings.microsoft.connect_button": "Connect Microsoft",
  "settings.microsoft.connecting": "Connecting...",
  "settings.microsoft.connected_success": "Microsoft connection completed.",
  "settings.microsoft.loading_status": "Loading Microsoft status...",
  "settings.microsoft.no_accounts": "No Microsoft accounts connected.",
  "settings.microsoft.selected_account": "Selected account",
  "settings.microsoft.select_account": "Select an account",
  "settings.microsoft.unnamed_account": "Unnamed account",
  "settings.microsoft.email_unavailable": "Email unavailable",
  "settings.microsoft.invalid_account": "Invalid account identity. Actions are disabled.",
  "settings.microsoft.malformed_status": "Microsoft status response is invalid. Account actions are disabled.",
  "settings.microsoft.status_error": "Could not load Microsoft status.",
  "settings.microsoft.connect_error": "Could not complete Microsoft authentication.",
  "settings.microsoft.disconnect_error": "Could not disconnect the Microsoft account.",
  "settings.microsoft.default_error": "Could not set the default Microsoft account.",
  "settings.microsoft.reauthorize_error": "Could not reauthorize the Microsoft account.",
  "settings.microsoft.popup_blocked": "The browser blocked the popup. Allow popups to continue.",
  "settings.microsoft.sync_period_saved": "Sync start date saved.",
  "settings.microsoft.sync_period_error": "Could not save the sync start date.",
  "settings.microsoft.sync_period_integer_error": "Select a valid date.",
  "settings.microsoft.sync_period_range_error": "Select a date between 365 days ago and today.",
  "settings.microsoft.save_sync_period": "Save date",
  "settings.microsoft.make_default": "Make default",
  "settings.microsoft.reauthorize": "Reauthorize",
  "settings.microsoft.disconnect": "Disconnect",
  "settings.microsoft.oauth_processing": "Processing Microsoft authentication...",
  "settings.microsoft.mail_preview_title": "Mail preview",
  "settings.microsoft.drive_preview_title": "Drive preview",
  "settings.microsoft.sharepoint_preview_title": "SharePoint preview",
  "settings.microsoft.no_preview_items": "No preview items to show.",
  "settings.microsoft.table.account": "Account",
  "settings.microsoft.table.status": "Status",
  "settings.microsoft.table.sync_period": "Sync from",
  "settings.microsoft.table.default": "Default",
  "settings.microsoft.table.actions": "Actions",
  "settings.microsoft.connected": "接続済み",
  "settings.microsoft.connection_status_title": "接続状態",
  "settings.microsoft.sync_process_title": "アカウント同期",
  "settings.microsoft.sync.mail_sync_status": "メール同期状態",
  "settings.microsoft.sync.drive_sync_status": "ドライブ同期状態",
  "settings.microsoft.sync.last_mail_sync_at": "最終メール同期",
  "settings.microsoft.sync.last_drive_sync_at": "最終ドライブ同期",
  "settings.microsoft.sync.last_read_email_date": "最後に同期したメールの日付",
  "settings.microsoft.sync.last_sync_date": "最終同期日",
  "settings.microsoft.sync.emails_processed": "処理済みメール数",
  "settings.microsoft.sync.period": "同期期間",
  "settings.microsoft.sync.not_set": "未設定",
  "settings.microsoft.sync.all": "すべて",
  "settings.microsoft.diagnostics_title": "診断",
  "settings.microsoft.audit_title": "監査とセキュリティ",
  "settings.microsoft.manage_access_link": "Microsoftアカウントの権限を管理",
  "settings.microsoft.privacy_policy": "プライバシーポリシー",
  "settings.microsoft.terms_of_service": "利用規約",
  "settings.microsoft.preview_unavailable": "プレビュー不可。バックエンドエンドポイントはまだアクティブではありません。",
  "settings.microsoft.no_mail_items": "表示するメールがありません。",
  "settings.microsoft.no_drive_items": "表示するOneDriveファイルがありません。",
  "settings.microsoft.no_sharepoint_items": "表示するSharePointファイルがありません。",
  "settings.microsoft.table.subject": "件名",
  "settings.microsoft.table.from": "差出人",
  "settings.microsoft.table.received_at": "受信日時",
  "settings.microsoft.table.name": "名前",
  "settings.microsoft.table.type": "種類",
  "settings.microsoft.table.size": "サイズ",
  "settings.microsoft.table.modified": "更新日時",
  "settings.microsoft.table.location": "場所",
  "settings.microsoft.table.time": "時間",
  "settings.microsoft.table.message": "メッセージ",
  "settings.microsoft.table.scopes": "権限",
  "settings.microsoft.mail_reauth_required": "このアカウントはメール読み込みに再認証が必要です。",
  "settings.microsoft.drive_reauth_required": "このアカウントはファイル読み込みに再認証が必要です。",
  "settings.microsoft.reauthorize_preview": "再認証",
  "settings.microsoft.mail_not_found": "Microsoftアカウントが見つかりません。設定を確認してください。",
  "settings.microsoft.drive_not_found": "MicrosoftドライブがみつかりŁません。",
  "settings.microsoft.table.body_preview": "プレビュー",
  "settings.microsoft.table.has_attachments": "添付ファイル",
  "settings.microsoft.table.created_by": "作成者",
};
